// latest: zhangmyh 2017-4-11 4:24 PM
import { Model } from 'common'

Model.define('evalapply.extra', {
  meta: {
    id: '',
    extraItem: '',
    memo: '',
    mode: '',
    type: ''
  }
})



// WEBPACK FOOTER //
// ./src/data/model/evaluationApply/evaExtra.js